const Application = {
    CHEMITY: 'chemity',
    SUSTAINITY: 'sustainity',
};

const currentApplication = window.location.host.includes(Application.SUSTAINITY) ? Application.SUSTAINITY : Application.CHEMITY;

function isChemity() {
    return currentApplication === Application.CHEMITY;
}

function isSustainity() {
    return currentApplication === Application.SUSTAINITY;
}

export {
    isChemity,
    isSustainity,
    Application
}
